import React, { useMemo } from 'react';
import OrganizationAnalyticsBarChart from './OrganizationAnalyticsBarChart';
import { mapIdsToLabels } from './chartUtils';

const OrganizationChatterTotalEarningsByChatterChart = ({ data, chatterLabelMap, pending }) => {
  const { categories, series } = useMemo(
    () => ({
      categories: mapIdsToLabels(data?.chatterIds, chatterLabelMap),
      series: [{ name: 'Earnings', data: data?.earnings || [] }],
    }),
    [data, chatterLabelMap],
  );

  return (
    <OrganizationAnalyticsBarChart
      title="Total Earnings By Chatter"
      subtitle="Direct comparison of earnings for the selected chatters."
      categories={categories}
      series={series}
      pending={pending}
      emptyText="Select creators and chatters to load total earnings."
    />
  );
};

export default OrganizationChatterTotalEarningsByChatterChart;
